import * as z from "zod";

export const refreshShopifyPlan = {
  name: "refreshShopifyPlan" as const,
  input: z.void(),
  output: z.void(),
};
